import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'antd';
import moment from "moment";
import { allapiAction } from '../../Redux/common/action';
import NewHeader from '../Layout/NewHeader';
import NewSidebar from '../Layout/NewSidebar';
import { URL } from '../../Service/url';

function MapList() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pagev = searchParams.get("page");
    const searchData = searchParams.get("search");

    const page = pagev == null ? 1 : pagev;
    const search = searchData == null ? "" : searchData;
    const [pages, setPage] = useState(1);

    // Fetch all categories from Redux
  const all_categories_List = useSelector((state) =>
    state?.allapi?.all_categories_List ? state?.allapi?.all_categories_List : []
  );

    // const listdata = allCategories?.docs || [];

    useEffect(() => {
        dispatch(allapiAction.getCategory());
        return () => {};
    }, [location]);

    const hendlePahegi = (e) => {
        setPage(e);
        navigate("/direct-team?page=" + e + "&&search=" + search);
    };

    const columns = [
        {
            title: "S.No.",
            dataIndex: "sno",
            key: "sno",
            render: (value, item, index) => (page - 1) * 10 + index + 1,
        },
        {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (value, item) => (
                <div style={{ width: "100px" }}>
                    <img
                        style={{ width: "100%" }}
                        src={URL?.API_BASE_URL + item?.image}
                        alt={item?.name}
                    />
                </div>
            ),
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (value) => (value ? "Active" : "Inactive"),
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (value) => moment(value).format("DD/MM/YYYY"),
        },
        {
            title: "Action",
            key: "action",
            render: (value, item) => (
                <button
                    className="filter-button ml-3"
                    onClick={() => navigate(`/category-detail/${item?._id}`)}
                >
                    <i className="fa fa-eye"></i> View
                </button>
            ),
        },
    ];

    return (
        <div>
            <NewHeader />
            <NewSidebar />

            <div className="main">
                <div className="my">
                    {/* <div className="container mt-5 pt-5 mb-5 pb-5">

                        <div className="tableResponsive mt-10">
                                                      {all_categories_List &&
              all_categories_List?.map((data, i) => {
                return (
                            <Table
                                className="table antd_table custom-table"
                           id={data?.slug}
                      data-categoryslug={data?.slug}
                      data-toggle="tab"
                      href={`#${data?.slug}`}
                      role="tab"
                      aria-controls={data?.slug}
                      aria-selected="false"

                        // onClick={() => {
                        //     hendleToChange(data?.name, data?._id);
                        //   }}
                            />
                              );
              })}
                        </div>
                         
                    </div> */}
{all_categories_List && (
  <table className="table table-hover table-striped table-bordered text-center shadow custom-table">
    <thead className="table-danger">
      <tr >
       
        <th style={{ fontSize: '18px' }}>Logo</th>
        <th style={{ fontSize: '18px' }}>Category Name</th>
      </tr>
    </thead>
    <tbody>
      {all_categories_List.map((data, i) => (
        
        <tr key={i}>
          
          <td>
           <img
  src={URL?.API_BASE_URL + data?.image}
  alt={data?.name}
  className="zoomable-img"
  style={{
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    border: '2px solid #dc3545',
    padding: '4px',
    backgroundColor: '#fff',
    transition: 'transform 0.3s ease',
  }}
/>
          </td>
          <td
            className="fw-bold"
            style={{
              color: '#dc3545',
              fontSize: '18px',
              verticalAlign: 'middle',
            }}
          >
            {data?.name}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
)}

                    {/* STYLE TAG */}
                    <style jsx="true">{`
                        .custom-table {
                            background: #fff;
                            border-radius: 12px;
                            overflow: hidden;
                            box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
                            margin-top: 20px;
                            min-width: 800px;
                        }
                        .custom-table .ant-table-thead > tr > th {
                            background-color: #a57b2e;
                            color: #000000;
                            font-weight: 600;
                            font-size: 16px;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                            padding: 16px;
                        }
                        .custom-table .ant-table-tbody > tr > td {
                            font-size: 15px;
                            padding: 14px;
                            background-color: #fafafa;
                            border-bottom: 1px solid #eee;
                        }
                        .custom-table .ant-table-tbody > tr:hover > td {
                            background-color: #f0f8ff;
                            transition: all 0.3s;
                        }
                        .custom-table .ant-pagination {
                            margin-top: 20px;
                            text-align: center;
                        }
                        .tableResponsive {
                            width: 100%;
                            overflow-x: auto;
                        }
                        @media (max-width: 768px) {
                            .custom-table {
                                min-width: 600px;
                            }
                        }
                        @media (max-width: 576px) {
                            .custom-table {
                                min-width: 500px;
                            }
                        }
                    `}</style>
                </div>
            </div>
        </div>
    );
}

export default MapList;
